import React from 'react';
import { Route } from 'react-router-dom';
import LazyRoute from 'lazy-route';

const paymentRoutes = [
  <Route
    key="payment"
    exact
    path="/payment"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/Pembayaran")}
      />
    )}
  />,
];

export default paymentRoutes; 